import React from "react";
import "./stepCard.scss";

type StepCardProps = {
    descriptionTitle: string;
    description: React.ReactNode;
    mainImage: string;
};

const StepCard = ({ descriptionTitle, description, mainImage }: StepCardProps) => {
    const isWarning = mainImage?.includes("advertencia") ? true : false;
    return (
        <div className="m-step-card">
            <div className={`m-step-card__image ${isWarning ? 'm-step-card__image warning' : ''}` }>
                <img src={mainImage} alt={descriptionTitle} />
            </div>
            <div className="m-step-card__content">
                <div className="m-step-card__content__title">
                    <h3>{descriptionTitle}</h3>
                </div>
                <div className="m-step-card__content__description">
                    {description}
                </div>
            </div>
        </div>
    );
};

export default StepCard;